import { useEffect } from 'react';
import { useState } from 'react';
import { Image } from '../../../Image/Image';
import { FicheType } from '../../FicheType/FicheType';
import { MoreInfo } from '../../MoreInfo/MoreInfo';
import './FicheBeleefdagen.scss';

export const FicheBeleefdagen = (props) => {
    const [bodyItems, setBodyItems] = useState([]);

    useEffect(() => {

        setBodyItems(props.processFicheItems(props.data.body.items))

    }, [JSON.stringify(props.data.body.items)]);

    return (
        <div
            className={`c-fiche c-beleefdagen  ${props.data?.link ? "u-has-detail" : ""}`}
            onClick={() => {
                if (props.data?.link) {
                    window.open(props.data.link, "_blank");
                }
            }}
            data-aos="fade-up"
        >
            <div>
                <FicheType type={props.data.type}>
                    <i class="fa-fw fa-fw fas fa-calendar-alt"></i>
                </FicheType>
                <div className="image" title="Meer over">
                    <Image alt={(props.data.image && props.data.image.alt)} src={(props.data.image && props.data.image.url)} />
                </div>
                <header className="c-fiche__header">
                    {(props.data.tagIcon &&
                        <div className="c-tag-list">
                            <div className="c-tag corona" title="coronaproof">
                                <Image alt={props.data.title} src={props.data.tagIcon.url} />
                            </div>
                        </div>)}
                    <h2 className="title" title={props.title}>
                        {props.data.title}
                    </h2>
                    {props.data.text}
                </header>
                <div className="c-fiche__body">
                    <ul>
                        {bodyItems}
                    </ul>
                </div>
                {
                    props.data.link &&
                    <MoreInfo
                        data={{ hasDetail: true }}
                        url={props.data.link}
                        cta={props.dictionary.subscribe}
                    />
                }
            </div>
        </div>
    );
}